export const PAGE_SIZE = 20;

export const readable = (value, fallback = "Not set") => {
  if (!value) return fallback;

  return String(value)
    .toLowerCase()
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const formatDate = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const formatDateTime = (value) => {
  if (!value) return "";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

export const membershipUserId = (membership) =>
  membership?.user?.id || membership?.userId || "";

export const membershipUserName = (membership) => {
  if (!membership) return "User";

  const name = [
    membership.user?.firstName,
    membership.user?.middleName,
    membership.user?.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  return name || membershipUserId(membership) || "User";
};

export const membershipUserEmail = (membership) => membership?.user?.email || "";

export const membershipUserLabel = (membership) =>
  membershipUserName(membership) || membershipUserEmail(membership) || "User";

export const organizationName = (entity, fallback = "Organization") =>
  entity?.name ||
  entity?.businessName ||
  entity?.legalName ||
  entity?.displayName ||
  fallback;

export const subscriptionLabel = (subscription, fallback = "Subscription") =>
  subscription?.subscriptionPlanName ||
  subscription?.subscriptionPlan?.name ||
  subscription?.name ||
  subscription?.subscriptionPlanCode ||
  subscription?.subscriptionPlan?.code ||
  fallback;

export const planLabel = (plan, fallback = "Subscription option") =>
  plan?.name || plan?.code || fallback;

export const statusColor = (status) => {
  const normalized = String(status || "").toUpperCase();
  if (normalized === "ACTIVE" || normalized === "ACCEPTED") return "green";
  if (normalized === "PENDING" || normalized === "INVITED") return "gold";
  if (["SUSPENDED", "DECLINED", "CANCELLED", "REMOVED"].includes(normalized)) {
    return "red";
  }
  return "blue";
};

export const hasAdminAccess = (membership) => {
  const values = [
    ...(membership?.roleNames || []),
    ...(membership?.privilegeScopes || []),
  ].map((value) => String(value).toUpperCase());

  return values.some(
    (value) =>
      value.includes("ADMIN") ||
      value.includes("OWNER") ||
      value.includes("PRODUCT_ADMIN"),
  );
};
